import React from 'react'
import {
  CFSelect,
  CFView,
  CFImage,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { orderPickupButton } from 'images'
import { dispatch } from 'store'

export default () => {
  return (
    <CFSelect selector={dispatch.restaurant.getSelectedLocationId}>
      {locationId => (
        <CFView>
          <MobileScreen>
            <a
              href={`https://order.codefusion.tech/restaurants/looFMAKgFoh6s0kGoagQ/locations/wRviRcbn8emKjQzzDW3i`}
            >
              <CFView hover>
                <CFImage
                  src={orderPickupButton}
                  w="100%"
                  maxWidth="320px"
                  alt="Order Pickup Button"
                />
              </CFView>
            </a>
          </MobileScreen>
          <DefaultScreen>
            <a
              href={`https://order.codefusion.tech/restaurants/looFMAKgFoh6s0kGoagQ/locations/wRviRcbn8emKjQzzDW3i`}
            >
              <CFView hover>
                <CFImage
                  w="100%"
                  src={orderPickupButton}
                  alt="Order Pickup Button"
                  maxWidth="280px"
                />
              </CFView>
            </a>
          </DefaultScreen>
        </CFView>
      )}
    </CFSelect>
  )
}
